<template>
  <div>
    <tree-node
      v-for="(node, index) in nodes"
      :key="index"
      :node="node"
      :parents="[]"
      :index="index"
    ></tree-node>
  </div>
</template>

<script>
export default {
  props: {
    nodes: { type: Array }
  },
  data () {
    return {
    }
  },
  computed: {
    menuType () {
      return this.$route.name.startsWith('adminUser') ? 'user' : 'master'
    }
  },
  methods: {
  },
  components: {
    TreeNode: () => import('./TreeNode')
  }
}
</script>
